import { useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { GALLERY } from "@/data/deviceScreens";

const W = 640;
const H = 1137;

const META = {
  "icd10-cm-2026": {
    eyebrow: "ICD-10-CM 2026 · Medical Codes",
    headlines: [
      ["Every 2026 code.", "Always offline."],
      ["Favorites and folders,", "synced by iCloud."],
      ["One purchase.", "Yours for good."],
    ],
  },
  "icd10-on-the-go": {
    eyebrow: "ICD-10 On the Go · 2026",
    headlines: [
      ["The flagship", "ICD-10 reference."],
      ["Reports and printing,", "built in."],
      ["Automation for", "professional work."],
    ],
  },
  "icd10-2026": {
    eyebrow: "ICD 10 2027",
    headlines: [
      ["Type HTN.", "Find I10."],
      ["Search that shows", "its work."],
      ["Official 2027 edition.", "2026 stays free."],
    ],
  },
  acroly: {
    eyebrow: "Acroly · Medical Abbreviations",
    headlines: [
      ["Any abbreviation.", "Instantly."],
      ["8,000+ terms.", "Zero ads."],
      ["Share folders", "with your team."],
    ],
  },
};

function PromoFrame({ eyebrow, headline, children }) {
  return (
    <div style={{ width: W, height: H }} className="relative flex flex-col items-center overflow-hidden bg-white">
      <div className="pt-16 text-center">
        <p className="flex items-center justify-center gap-2.5 text-[13px] font-semibold uppercase tracking-[0.28em] text-ink/45">
          <Plus className="h-3.5 w-3.5 text-cobalt" strokeWidth={2.5} aria-hidden="true" />
          {eyebrow}
        </p>
        <h1 className="mt-6 font-sans text-[52px] font-bold leading-[1.06] tracking-[-0.02em] text-ink">
          {headline.map((line) => (
            <span key={line} className="block">{line}</span>
          ))}
        </h1>
      </div>
      <div className="absolute bottom-[-140px] w-[420px] rounded-[64px] bg-ink p-[12px] shadow-[0_50px_100px_-40px_rgba(17,17,16,0.45)]">
        <div className="relative h-[860px] overflow-hidden rounded-[52px] bg-white">
          <div className="absolute left-1/2 top-3.5 z-20 h-[30px] w-[120px] -translate-x-1/2 rounded-full bg-ink" aria-hidden="true" />
          {children}
        </div>
      </div>
    </div>
  );
}

export default function Studio() {
  const [params] = useSearchParams();
  const appKey = params.get("app");
  const apps = appKey && META[appKey] ? { [appKey]: META[appKey] } : META;
  return (
    <div className="absolute left-0 top-0" style={{ width: W }} data-testid="studio">
      {Object.entries(apps).map(([slug, meta]) =>
        meta.headlines.map((headline, i) => (
          <PromoFrame key={`${slug}-${i}`} eyebrow={meta.eyebrow} headline={headline}>
            {GALLERY[slug][i](true)}
          </PromoFrame>
        ))
      )}
    </div>
  );
}
